class OpenGorgiasWidget extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.addEventListener('click', this.handleShow)

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const gorgiasChatContainer = document.querySelector('#gorgias-chat-container');
          if (gorgiasChatContainer) {
            gorgiasChatContainer.style.display = 'none';
            observer.disconnect();
            break;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  handleShow (event) {
    const gorgiasChatContainer = document.querySelector('#gorgias-chat-container');
    gorgiasChatContainer.style.display = 'block';

    GorgiasChat.open()
  }
}

if (!customElements.get('open-gorgias-widget')) {
  customElements.define('open-gorgias-widget', OpenGorgiasWidget)
}
